/**
 * useAllAvailability — every operator's availability grid (B.12-R8 «Графики»
 * tab, readonly). GET /api/operator-availability/all → opId → date → hour →
 * status. OO-only.
 */
import { useEffect, useState } from "react";
import { api } from "../api/client";

export type AvailAll = Record<string, Record<string, Record<string, string>>>;

interface Resp { results?: AvailAll }

export function useAllAvailability(): { data: AvailAll; loading: boolean } {
  const [data, setData] = useState<AvailAll>({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    api<Resp>("/api/operator-availability/all")
      .then((r) => { if (alive) { setData(r.results ?? {}); setLoading(false); } })
      .catch(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { data, loading };
}
